var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blockquote-wrapper"},[_c('base-font',{staticClass:"italic-text"},[_vm._v(_vm._s(_vm.title))]),_c('base-font',{staticClass:"description",attrs:{"variant":"paragraph"}},[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }